import React, { useEffect, useState } from 'react';
import Status from './../../../../TopQualities/status.jsx';
import './Toast.scss';

const Toast = ({ text, time = 3000, toastVisible, setToastVisible, shouldReload = true }) => {
  useEffect(() => {
    setToastVisible(true);
    const timer = setTimeout(() => {
      setToastVisible(false);
    }, time);
    return () => clearTimeout(timer);
  }, [time]);

  if (!toastVisible) return null;

  setTimeout(() => {
    setToastVisible(false);
    if (shouldReload) {
      window.location.reload();
    }
  }, time);

  return (
    <div className="toast">
      <span className="toast__icon">
        <Status isFilled={true} width={1000} height={1000} />
      </span>
      <span className="toast__message">{text}</span>
      <button className="toast__close" onClick={() => setToastVisible(false)}>
        ✕
      </button>
    </div>
  );
};

export default Toast;
